<template>
  <div>
    <el-row style="display: flex;margin-bottom: 10px;">
      <el-col :span="4" v-if="theProjectId== 0" >
        <el-select v-model="form.projectId" @change="theProjectAllChange" size="small" filterable clearable
          placeholder="请选择项目">
          <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId" :label="item.projectName"
            :value="item.projectId">
          </el-option>
        </el-select>
      </el-col>
      <el-col v-if="form.projectId">
        <el-button v-if="addAttendanceSet"
          @click="$form('addAttendanceSet')"
          size='small'
          type="primary"
          style="float:right"
          icon='el-icon-circle-plus'
        >添加打卡设置
        </el-button>
      </el-col>
    </el-row>
    <div>
        <myform
          :viewobj='{
            addAttendanceSet:    [ "新增打卡设置", "el-icon-circle-plus" ],
            updateAttendanceSet: [ "修改打卡设置", "el-icon-edit-outline"],
            $succeed$: getAttendanceSetList
          }'
            @confirm='myform'
          @close='$form("addAttendanceSet","reset")'
          >
          <hide slot='projectId' />
          <hide slot='yasId' />
          <template v-slot:yasDate="{Myformdata}" >
            <el-date-picker
                  v-model="Myformdata.yasDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
          </template>
          <template v-slot:yasTimeStart="{Myformdata}" >
           <el-date-picker
                 v-model="Myformdata.yasTimeStart"
                 type="datetime"
                 value-format="yyyy-MM-dd HH:mm:ss"
                 placeholder="选择开始日期时间">
               </el-date-picker>
          </template>
          <template v-slot:yasTimeEnd="{Myformdata}" >
           <el-date-picker
                 v-model="Myformdata.yasTimeEnd"
                 type="datetime"
                 value-format="yyyy-MM-dd HH:mm:ss"
                 placeholder="选择结束日期时间">
               </el-date-picker>
          </template>
        </myform>
        <mytable
          :tableColums='tableColums_getAttendanceSetList'
          api='getAttendanceSetList'
          xupdateapi='updateOpportunityBusinessCheckImage'
          :height="H-165" >
        </mytable>
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return {
        theProjectId:0,
        value:'',
        form:{
          projectId:'',
          yasDate:'',
          yasCommand:'',
          yasTimeStart:'',
          yasTimeEnd:'',
          yasDes:'',
        },
        tableColums_getAttendanceSetList:{
          $selection: false,

          // oiType: '限制字段key',
          yasDes:'打卡标题',
          yasDate: '打卡日期',
          
          yasCommand: '打卡口令',
          yasTimeStart:'开始打卡时间',
          yasTimeEnd:'结束打卡时间',
          
          $operation: [
            '操作', 200,
            this.updateAttendanceSet && `@text: 编辑#success
             @click: $form("updateAttendanceSet",$row)
            `,
            this.deleteAttendanceSet && `@text: 删除#danger
             @click: _confirm('确定要删除该填写项约束吗?')
                     .trigger('deleteAttendanceSet',{yasId:$row.yasId})
                     .trigger('getAttendanceSetList',{projectId:form.projectId})
            `,
          ],
        }
      }
    },
    methods:{
      myform(submit, Myformdata){
        Myformdata.projectId = this.form.projectId;
           submit();
      },
      theProjectAllChange(e){
        if(e == ''){
          return  this.form.projectId = e;
        }
        this.form.projectId = e;
        this.getAttendanceSetList({projectId:this.form.projectId})
      },
    },
    created(){
      this.getProjectList({
        pageSize: 0
      });

      this.theProjectId = A.local("$projectId");
      if (this.theProjectId != 0) {
        this.form.projectId = this.theProjectId;
      }
      this.getAttendanceSetList({projectId:this.form.projectId})
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/model/PunchCardSet.vue